export enum PaymentIntervalEnum {
  EVERY_SIX_MONTHS = 'EVERY_SIX_MONTHS',
  EVERY_TWO_YEARS = 'EVERY_TWO_YEARS',
  MONTH = 'MONTH',
  MULTI_YEAR = 'MULTI_YEAR',
  ONE_OFF = 'ONE_OFF',
  QUARTER = 'QUARTER',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}
